module.exports = __webpack_public_path__ + "img/subject_banner11.08c0f1b0.png";